<template>
    <div class="public-client-page">
        <loadingScreen/>
        <nav class="navbar navbar-light bg-primary" v-if="this.allotment?.id">
            <a class="">
                <img style="max-width: 100px; max-height: 50px"
                     :src="allotment.image ? allotment.image : '@/assets/img/logo-pb.png'"
                >
            </a>
        </nav>
        <div class="main-container" :class="widthMd('800', '>') ? '' : 'pl-0 pr-0'">
            <WizardComponent :steps="steps" ref="wizard"
                             :before-change="validateChangeStep"
                             finish-label="Salvar"
                             show-required-badge
                             :finish-disabled="clientPublicType !== 'natural' && clientPublicType !== 'legal'"
                             :show-finish-only-last-step="false"
                             @finish="saveClient"
                             :navigation-position="widthMd('1400', '>') ? 'left' : 'top'">
                <template #data_principal>
                    <createPublicPersonStepOne ref="data_principal"></createPublicPersonStepOne>
                </template>
                <template #address>
                    <createPublicPersonStepAddress ref="address"></createPublicPersonStepAddress>
                </template>
                <template #conjuge>
                    <createPublicPersonStepConjuge ref="conjuge"></createPublicPersonStepConjuge>
                </template>
                <template #anexos>
                    <createPublicPersonStepAnex ref="anexos"></createPublicPersonStepAnex>
                </template>
                <template #comercial_address>
                    <createPublicStepComercialAddress ref="comercialAddress"></createPublicStepComercialAddress>
                </template>
                <template #responsible>
                    <createPublicStepClientResponsibleLegal ref="responsible"></createPublicStepClientResponsibleLegal>
                </template>
            </WizardComponent>
        </div>
    </div>
</template>

<script>
import LoadingScreen from '@/components/layouts/loadScreenComponent';
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import 'vue-advanced-cropper/dist/style.css';
import Public from "@/services/Public";
import Drive from "../../services/Drive";
import AttributesValidationsMixin from '../../mixins/AttributesValidationsMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import widthMd from '../../mixins/widthMd';
import Allotments from '../../services/Allotments';
import WizardComponent from '../../components/layouts/WizardComponent';
import createPublicPersonStepOne from './steps_public/createPublicPersonStepOne';
import createPublicPersonStepAddress from './steps_public/createPublicPersonStepAddress';
import createPublicPersonStepConjuge from './steps_public/createPublicPersonStepConjuge';
import createPublicPersonStepAnex from './steps_public/createPublicPersonStepAnex';
// import {normalizeTaxpayer} from '@/Helpers/Taxpayer';
import createPublicStepComercialAddress from './steps_public/createPublicStepComercialAddress';
import createPublicStepClientResponsibleLegal from './steps_public/createPublicStepClientResponsibleLegal';

export default {
    name: 'publicClient',
    components: {
        LoadingScreen,
        createPublicStepComercialAddress,
        createPublicPersonStepAnex,
        createPublicPersonStepConjuge,
        WizardComponent,
        createPublicPersonStepOne,
        createPublicPersonStepAddress,
        createPublicStepClientResponsibleLegal,
    },
    mixins: [Validate, AttributesValidationsMixin, widthMd],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    watch: {
        clientPublicType() {
            if (this.clientPublicType === 'natural') {
                this.listAnnexTypePublicAction({companyId: this.companyId, vinculedAt: 'fisica'});
                this.steps = [
                    {
                        id: 'data_principal',
                        description: 'Dados principais do cliente',
                        label: 'Dados Pessoais',
                        icon: 'icon-account_box',
                        slot: 'data_principal'
                    },
                    {
                        id: 'address',
                        description: 'Cadastro de Endereço',
                        optional: !this.requiredClassValidation('address_id'),
                        label: 'Endereço',
                        icon: 'icon-location',
                        slot: 'address'
                    },
                    {
                        id: 'comercial_address',
                        description: 'Cadastro de Endereço Comercial',
                        optional: !this.requiredClassValidation('comercial_address_id'),
                        label: 'Endereço Comercial',
                        icon: 'icon-store_mall_directory',
                        slot: 'comercial_address'
                    },
                    {
                        id: 'responsible',
                        description: 'Cadastro do Responsável Legal caso exista',
                        label: 'Responsável Legal',
                        optional: true,
                        icon: 'icon-user',
                        slot: 'responsible'
                    },
                ];
            } else if (this.clientPublicType === 'legal') {
                this.listAnnexTypePublicAction({companyId: this.companyId, vinculedAt: 'juridica'});
                this.steps = [
                    {
                        id: 'data_principal',
                        description: 'Informações principais',
                        label: 'Dados Principais',
                        icon: 'icon-account_box',
                        slot: 'data_principal'
                    },
                    {
                        id: 'address',
                        description: 'Endereço',
                        optional: !this.requiredClassValidation('address_id'),
                        label: 'Endereço',
                        icon: 'icon-location',
                        slot: 'address'
                    },
                    {
                        id: 'responsible',
                        description: 'Cadastro do Responsável Legal caso exista',
                        label: 'Responsável Legal',
                        optional: true,
                        icon: 'icon-user',
                        slot: 'responsible'
                    },
                ];
            }
            if((this.clientPublicType === 'natural' || this.clientPublicType === 'legal') && this.hasPlanDrive){
                this.steps.push({
                    id: 'anexos',
                    description: 'Anexos de documentações',
                    label: 'Anexos',
                    icon: 'icon-attach_file',
                    slot: 'anexos'
                })
            }
        },
        typesAnnex(){
            if(this.hasPlanDrive){
                const optional = !this.typesAnnex?.required?.length;
                this.changeCompletedStep('anexos', optional, true);
            }
        },
        requiredConjuge(val){
            if (val){
                this.steps = this.steps?.filter(i => i.id !== 'conjuge');
                this.steps.push({
                    id: 'conjuge',
                    description: 'Cadastro do Cônjuge',
                    label: 'Cônjuge',
                    icon: 'icon-people',
                    slot: 'conjuge'
                })
            }else {
                this.steps = this.steps?.filter(i => i.id !== 'conjuge');
            }
        }
    },
    computed: {
        ...mapState({
            itemsValidations: 'itemsValidations',
            itemsValidationsRequired: 'itemsValidationsRequired',
            clientPublicType: (state) => state.publicClient.clientPublicType,
            typesAnnex: (state) => state.publicClient.typesAnnex,
            naturalPerson: (state) => state.publicClient.naturalPerson,
            legalPerson: (state) => state.publicClient.legalPerson,
            address: (state) => state.publicClient.address,
            anexes: (state) => state.publicClient.anexes,
            responsible: (state) => state.publicClient.responsible,
            commercialAddress: (state) => state.publicClient.commercialAddress,
            spouse: (state) => state.publicClient.spouse,
            attrsPhisical: (state) => state.publicClient.attrsPhisical,
            attrsJuridical: (state) => state.publicClient.attrsJuridical,
            requiredConjuge: (state) => state.publicClient.requiredConjuge,
        }),
    },
    data() {
        return {
            steps: [{
                id: 'data_principal',
                description: 'Informações principais',
                label: 'Dados Principais',
                icon: 'icon-account_box',
                slot: 'data_principal'
            }],
            companyId: this.$route.params.companyId,
            invalid: {},
            allotment: null,
        }
    },
    mounted() {
        this.$store.commit('changeLoading', true);
        this.verifyDrivePermission();
        this.publicClientGetAtributesValidateAction({context: 'clients_phisical', companyId: this.companyId});
        this.publicClientGetAtributesValidateAction({context: 'clients_juridical', companyId: this.companyId});
        this.listMaritalStatusesPublicAction({companyId: this.companyId});
        this.loadAllotment();
        this.checkUrlContinue();
    },
    methods: {
        ...mapActions({
            publicClientGetAtributesValidateAction: 'publicClientGetAtributesValidateAction',
            listAnnexTypePublicAction: 'listAnnexTypePublicAction',
            listMaritalStatusesPublicAction: 'listMaritalStatusesPublicAction',
            createPublicClientAction: 'createPublicClientAction',
        }),
        ...mapMutations({
            clearStatePubliClientMutation: 'clearStatePubliClientMutation',
        }),
        saveClient(activeStep){
            let can_save = this.validateChangeStep({currentStep:activeStep});
            if (!can_save){
                this.toast.info(`Etapa: ${activeStep.label}, possui campos obrigatórios não preenchidos!`);
                return;
            }
            this.steps.forEach(s => {
                if (!s.completed){
                    if (!s.optional){
                        can_save = false;
                    }
                }
            })
            if (!can_save){
                this.toast.info('Por favor conclua todas as etapas obrigatórias!');
                return;
            }
            if (this.validateNotHasTaxpayerDuplicated()){
              return;
            }
            let dataSave = this.clientPublicType === 'natural' ? this.naturalPerson : this.legalPerson;
            dataSave.allotment_id = this.$route.params?.allotmentId;
            dataSave.created_by = this.$route.params?.userId;
            dataSave.type = this.clientPublicType === 'natural' ? 'phisical' : 'juridical';
            dataSave.address = this.address?.cep ? this.address : {};
            dataSave.documents = this.anexes;
            dataSave.responsible = this.responsible.taxpayer || this.responsible.id ? this.responsible : {};
            if (this.clientPublicType === 'natural'){
                dataSave.comercial_address = this.commercialAddress?.cep ? this.commercialAddress : {};
                if (this.spouse.taxpayer || this.spouse.id){
                    dataSave.conjuge = this.spouse;
                    dataSave.conjuge.marital_status_id = dataSave.marital_status_id;
                    dataSave.conjuge.wedding_date = dataSave.wedding_date;
                    dataSave.conjuge.marriage_certificate_registration = dataSave.marriage_certificate_registration;
                }else {
                    dataSave.conjuge = {};
                }
            }
            this.$store.commit('changeLoading', true);
            this.createPublicClientAction({
                client:dataSave,
                companyId: this.companyId,
                key: process.env.VUE_APP_KEY_TO_PUBLIC_ACCESS,
            }).then(() =>{
                this.clearStatePubliClientMutation();
                this.steps = [{
                    id: 'data_principal',
                    description: 'Informações principais',
                    label: 'Dados Principais',
                    icon: 'icon-account_box',
                    slot: 'data_principal'
                }];
                this.$refs.wizard.reset();
                this.toast.success('Cliente adicionado com sucesso!');
                this.$store.commit('changeLoading', false);
            }).catch((err) =>{
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            });
        },
        validateNotHasTaxpayerDuplicated(){
            let taxpayers = [];
            let error = false;
            if (this.clientPublicType === 'natural'){
                if (this.naturalPerson.taxpayer){
                    taxpayers.push(this.naturalPerson.taxpayer);
                }
                if (this.spouse.taxpayer){
                    if (taxpayers.find(t => t === this.spouse.taxpayer)){
                        this.toast.error('CPF informado para o conjuge está duplicado no cadastro!');
                        error = true
                    }else {
                        taxpayers.push(this.spouse.taxpayer);
                    }
                }
            }else if (this.legalPerson.taxpayer) {
                taxpayers.push(this.legalPerson.taxpayer);
            }
            if (this.responsible.taxpayer){
                if (taxpayers.find(t => t === this.responsible.taxpayer)){
                    this.toast.error('CPF informado para o responsável está duplicado no cadastro!');
                    error = true
                }else {
                    taxpayers.push(this.spouse.taxpayer);
                }
            }
            return error;
        },
        validateChangeStep({ currentStep }){
            if (currentStep.id === 'data_principal'){
                return this.validateDataPrincipal();
            }else if (currentStep.id === 'address'){
                return this.validateAddress();
            }else if (currentStep.id === 'comercial_address'){
                return this.validateComercialAddress();
            }else if (currentStep.id === 'conjuge'){
                return this.validateConjuge();
            }else if (currentStep.id === 'responsible'){
                return this.validateResponsible();
            }else if (currentStep.id === 'anexos'){
                return this.validateAnexos();
            }
            return false
        },
        validateConjuge(){
            if (this.$refs.conjuge.validateConjuge()){
                this.changeCompletedStep('conjuge', true);
                return true;
            }
            this.changeCompletedStep('conjuge', null);
            return false
        },
        validateResponsible(){
            if (this.$refs.responsible.validateResponsible()){
                this.changeCompletedStep('responsible', true);
                return true;
            }
            this.changeCompletedStep('responsible', null);
            return false
        },
        validateAnexos(){
            if (this.$refs.anexos.validateAnexos()){
                this.changeCompletedStep('anexos', true);
                return true;
            }
            this.changeCompletedStep('anexos', null);
            return false
        },
        validateComercialAddress(){
            if (this.$refs.comercialAddress.validateAddress()){
                this.changeCompletedStep('comercial_address', true);
                return true;
            }
            this.changeCompletedStep('comercial_address', null);
            return false
        },
        validateAddress(){
            if (this.$refs.address.validateAddress()){
                this.changeCompletedStep('address', true);
                return true;
            }
            this.changeCompletedStep('address', null);
            return false
        },
        changeCompletedStep(id, bool, isOptional = false)
        {
            this.steps.forEach(i => {
                if (i.id === id){
                    if (!isOptional){
                        i.completed = bool;
                    }else {
                        i.optional = bool;
                    }
                }
            })
        },
        validateDataPrincipal(){
            if(this.clientPublicType === 'natural'){
                if (this.$refs.data_principal.validateNaturalPerson()){
                    this.changeCompletedStep('data_principal', true);
                    return true;
                }
            }else if (this.clientPublicType === 'legal'){
                if (this.$refs.data_principal.validateLegalPerson()){
                    this.changeCompletedStep('data_principal', true);
                    return true;
                }
            }
            this.changeCompletedStep('data_principal', null);
            return false;
        },
        loadAllotment() {
            if (this.$route.params?.allotmentId) {
                this.$store.commit('changeLoading', true)
                Allotments.showPublic(this.$route.params.allotmentId, this.$route.params.companyId).then((resp) => {
                    this.allotment = resp.data;
                    this.$store.commit('changeLoading', false);
                }).catch(() => {
                    this.$store.commit('changeLoading', false);
                })
            }
        },
        verifyDrivePermission() {
            Drive.hasPlanDrive(this.$route.params.companyId).then(res => {
                this.hasPlanDrive = res.data.hasPlan;
            })
        },
        checkUrlContinue() {
            Public.checkUserIdAndCompanyIdExists(
                    {
                        companyId: this.$route.params.companyId,
                        usuarioId: this.$route.params.userId
                    }).then(resp => {
                if (!resp?.data?.continue) {
                    this.toast.error('URL Invalida');
                    this.$router.push({name: 'Home'});
                }
            }).catch(() => {
                this.$router.push({name: 'Home'});
            });
        },
    }
}
</script>

<style lang="less">
.size {
    width: 200px !important;
}

.size-modal {
    width: 100% !important;
}

.btn-background {
    width: 100%;
    font-size: large !important;
    font-weight: 600 !important;
    background-color: #adadad !important;
}

.modal-dialog {
    overflow-y: initial !important
}

.modal-row2 {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row2::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
    background: transparent !important;
}

.modal-row2::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

.modal-mask {
    position: fixed;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-header-color {
    color: white;
    background-color: #0e5e4e !important;
}

.right-content {
    justify-content: flex-end;
}

.swal2-container {
    z-index: 100000000000;
}

.user-avatar {
    max-width: 80px !important;
    max-height: 80px !important;
    border-radius: 50% !important;
    margin-bottom: 1.2rem !important;
}

.avatar-size {
    width: 80px !important;
    height: 80px !important;
}

.cropper-size {
    max-width: 350px !important;
    max-height: 275px !important;
}

.avatar .status {
    top: 62px;
    right: 2px;
    width: 25px;
    height: 25px;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    border: 4px solid #f0f0f0;
}

.camera {
    right: 1;
    bottom: 0;
    outline: 0;
    cursor: pointer;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    background-color: #f0f0f0;
}

.align-items {
    align-items: center;
}

.preview {
    border: dashed 1px rgba(255, 255, 255, 0.25);
}

.cropper {
    height: 100%;
    background: #DDD;
}

.hearder-custom {
    color: #333333 !important;
    background: #ffffff !important;
}

.close-custom {
    color: #000 !important;
}

.border-bottom {
    border-bottom: 1px solid #e6ebf1;
}

.border-top {
    background-color: #f2f4f9;
    border-top: 1px solid #e6ebf1;
}

html.dark-theme .public-client-page {
    background: var(--dark-bg);
    color: var(--dark-text-soft);
    min-height: 100vh;
}

html.dark-theme .public-client-page .main-container {
    background: var(--dark-bg) !important;
}

html.dark-theme .public-client-page .hearder-custom,
html.dark-theme .public-client-page .border-top {
    background: var(--dark-surface) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

html.dark-theme .public-client-page .border-bottom {
    border-color: var(--dark-border) !important;
}

html.dark-theme .public-client-page .close-custom,
html.dark-theme .public-client-page .bg-btn {
    color: var(--dark-text) !important;
}

html.dark-theme .public-client-page .bg-btn {
    background: var(--dark-surface-2) !important;
}

html.dark-theme .public-client-page .bg-btn:hover {
    background: var(--dark-primary) !important;
    color: #ffffff !important;
}

html.dark-theme .public-client-page .avatar .status,
html.dark-theme .public-client-page .camera,
html.dark-theme .public-client-page .cropper {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

.lg {
    max-width: 800px !important;
}
</style>

<style>

body.authentication {
    display: block;
    align-items: flex-start;
    justify-content: left;
    background: #eff1f5;
}

html.dark-theme body.authentication {
    background: var(--dark-bg) !important;
}

.modal-row {
    max-height: 100%;
    overflow-y: auto;
}

.modal-row::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
    background: transparent !important;
}

.modal-row::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

.secondary {
    border-radius: 3px;
    color: #ffffff !important;
    background-color: #383737;
}

.info-lot {
    border-radius: 7px;
    padding-bottom: 1px;
    padding-top: 6px;
}

.space-between {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-bottom-right-radius: calc(.3rem - 1px);
    border-bottom-left-radius: calc(.3rem - 1px);
}

.color-grey {
    color: #727272;
}

.font {
    font-size: 0.8rem;
}

.fab {
    position: fixed;
    bottom: 5px;
    right: 10px;
}

.fab button {
    cursor: pointer;
    width: 100%;
    height: 45px;
    border-radius: 20px;
    background-color: #383737;
    border: none;
    box-shadow: 0 1px 5px rgba(0, 0, 0, .4);
    font-size: 0.9rem;
    color: black;

    -webkit-transition: .2s ease-out;
    -moz-transition: .2s ease-out;
    transition: .2s ease-out;
}

.fab button.main {
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background-color: #0e5e4e !important;
    right: 0;
    bottom: 0;
    z-index: 20;
}

.fab ul {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0;
    padding-right: 5px;
    margin: 0;
    list-style: none;
    z-index: 10;

    -webkit-transition: .2s ease-out;
    -moz-transition: .2s ease-out;
    transition: .2s ease-out;
}

.fab ul li {
    display: flex;
    justify-content: flex-start;
    position: relative;
    margin-bottom: -10%;
    opacity: 0;

    -webkit-transition: .3s ease-out;
    -moz-transition: .3s ease-out;
    transition: .3s ease-out;
}

.fab ul li label {
    margin-right: 10px;
    white-space: nowrap;
    display: block;
    margin-top: 10px;
    padding: 5px 8px;
    background-color: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
    border-radius: 3px;
    height: 18px;
    font-size: 16px;
    pointer-events: none;
    opacity: 0;

    -webkit-transition: .2s ease-out;
    -moz-transition: .2s ease-out;
    transition: .2s ease-out;
}

.fab button.main:active,
.fab button.main:focus {
    outline: none;
    background-color: #000000;
    box-shadow: 0 3px 8px rgba(0, 0, 0, .5);
}

.fab button.main:active + ul,
.fab button.main:focus + ul {
    bottom: 70px;
}

.fab button.main:active + ul li,
.fab button.main:focus + ul li {
    margin-bottom: 8px;
    opacity: 1;
}

.fab button.main:active + ul li:hover label,
.fab button.main:focus + ul li:hover label {
    opacity: 1;
}

html.dark-theme .public-client-page .modal-row::-webkit-scrollbar-thumb,
html.dark-theme .public-client-page .modal-row2::-webkit-scrollbar-thumb {
    background: var(--dark-border-strong) !important;
}

html.dark-theme .public-client-page .fab ul li label {
    background: var(--dark-surface-2) !important;
    color: var(--dark-text) !important;
    box-shadow: 0 8px 18px rgba(2, 6, 23, .28) !important;
}
</style>

<style scoped>
.btn-holver {
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition-duration: 0.4s;
    cursor: pointer;
}

.bg-btn {
    background-color: #f2f4f9 !important;
    color: black !important;
}

.bg-btn:hover {
    background-color: #0e5e4e !important;
    color: white !important;
}

.custom-checkbox {
    padding-left: 32px !important;
}

.pointer {
    cursor: pointer;
}

@media screen and (max-width: 424px) {
    .mt-m-2 {
        margin-top: 1.1rem !important;
    }
}
</style>
